import classnames from 'classnames';
import React from 'react';
import InfoIcon from 'swag-client-common/components/icons/info-icon';
import { Tooltip } from 'swag-client-common/components/info/tooltip';
import { Placement } from 'swag-client-common/constants';
import { isMobile } from 'swag-client-common/utils/ui.utils';
import classes from './production-time-tooltip.scss';
const productionTimeTooltipStyles = {
  popper: classes.productionTimeTooltipPopper,
  tooltip: classes.tooltipRoot
};
const ProductionTimeTooltip = ({
  infoWrapperClassName = '',
  infoItemColor = '',
  placement = Placement.RIGHT,
  isEmbroideryEmbellishmentMethod
}) => {
  const tooltipText = isMobile() ? '' : `You will receive a production mockup within 48 hours. After you approve your mockup we will start on production. ${isEmbroideryEmbellishmentMethod ? 'If we are using embroidery to embellish your design, you will receive a sewout of your design. This may take up to a week.' : ''}`;
  return /*#__PURE__*/React.createElement(Tooltip, {
    title: tooltipText,
    placement: placement,
    mode: "light",
    className: infoWrapperClassName,
    classes: productionTimeTooltipStyles
  }, /*#__PURE__*/React.createElement(InfoIcon, {
    iconColor: infoItemColor,
    className: classnames(classes.infoButton),
    "aria-label": "Production time info"
  }));
};
export default ProductionTimeTooltip;